import * as React from 'react';
import cn from 'classnames';
import { EmptySectionContent } from '../section/EmptySectionContent';
import IconSVG from '../../../../styles/svg-icons';
import { Preloader } from '../../../common';
import { useDownloadDocument } from '../../../../effects/useDownloadDocument';
import { DownloadFile } from '../../../../types/amr-pipeline/models/DownloadedDocument';
import { Nullable } from '../../../../types/primitives/Nullable';

interface Props<TArgs extends any[]> {
    title: string;
    itemsCount?: number;
    children: React.ReactNode;
    emptyPlaceholder?: string;
    downloadAllFetch: (...args: TArgs) => Promise<DownloadFile>;
    downloadAllArgs: TArgs;
    fileNameForSave: Nullable<string>;
    renderAdditionalButton?: () => React.ReactNode;
}

export function DocumentGroup<TArgs extends any[]>({
    title,
    itemsCount = 0,
    children,
    downloadAllFetch,
    downloadAllArgs,
    fileNameForSave,
    emptyPlaceholder,
    renderAdditionalButton,
}: Props<TArgs>) {
    const [collapsed, setCollapsed] = React.useState(false);
    const { handleDownload, isDownloading } = useDownloadDocument({
        downloadRequest: downloadAllFetch,
        requestArgs: downloadAllArgs,
        fileNameForSave,
    });

    return (
        <div className="document-group-item">
            <div className="document-group-item-title">
                <div className="document-group-click-area" onClick={() => setCollapsed(!collapsed)}>
                    <IconSVG name="corner-arrow" className={`${!collapsed ? 'is-open' : ''}`} width={16} height={16} />
                    <h2>
                        {title}
                        {itemsCount ? <span className="header-title-count">{itemsCount}</span> : ''}
                    </h2>
                </div>
                {renderAdditionalButton?.()}
                {!!itemsCount && (
                    <div className="flex-item-right">
                        <a
                            className={cn("btn-link link-download-docs", {"btn-is-loading": isDownloading})}
                            href="/"
                            onClick={e => {
                                e.preventDefault();
                                handleDownload();
                            }}
                        >
                            <Preloader inProgress={isDownloading} small fullScreen={false} text="Downloading...">
                                <IconSVG name="downloadTemplate" width={16} height={16} />
                                <span className="align-middle">Download All</span>
                            </Preloader>
                        </a>
                    </div>
                )}
            </div>
            {!collapsed && (
                <div className="data-item-documents">
                    {itemsCount || !emptyPlaceholder ? children : <EmptySectionContent text={emptyPlaceholder} />}
                </div>
            )}
        </div>
    );
}
